/**
 * M5 运营数据 API 封装（03 号文档第 9 节）。
 * 对应后端 `apps/api/src/modules/analytics/analytics-event.controller.ts`。
 * 禁止 Mock：全部直接调用 apiRequest。
 */
import { apiRequest } from './client';

export interface AnalyticsOverview {
  rangeDays: number;
  users: { newUsers: number; activeUsers: number };
  activities: { listViews: number; detailViews: number; registrations: number; checkedIn: number };
  contents: {
    totalViews: number;
    totalDownloads: number;
    favorites: number;
    downloads: number;
  };
  search: { searchCount: number; noResultCount: number; noResultRate: number };
  community: { publishedPosts: number; comments: number; likes: number };
  notes: string[];
}

export function fetchAnalyticsOverview(days: number): Promise<AnalyticsOverview> {
  return apiRequest<AnalyticsOverview>('/analytics/overview', { query: { days } }).then(
    (result) => result.data,
  );
}

export interface SearchAnalyticsSummary {
  rangeDays: number;
  searchCount: number;
  noResultCount: number;
  noResultRate: number;
  topKeywords: Array<{
    keyword: string | null;
    keywordHash: string;
    isSensitive: boolean;
    count: number;
  }>;
  topNoResultKeywords: Array<{
    keyword: string | null;
    keywordHash: string;
    isSensitive: boolean;
    count: number;
  }>;
}

export function fetchSearchAnalyticsSummary(days: number): Promise<SearchAnalyticsSummary> {
  return apiRequest<SearchAnalyticsSummary>('/search-logs/summary', {
    query: { days, limit: 10 },
  }).then((result) => result.data);
}
